import React from 'react'
import ReferralListTable from '../../components/Admin/ReferralListTable';

const ReferralList = () => {
  return (
    <ReferralListTable />
  )
}

export default ReferralList;